import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ResponsiveService } from 'src/app/shared/services/responsive.service';
import { Subject, Subscription } from 'rxjs';
import { TeamHistory } from 'src/app/people/models/teamHistory';
import { PersonDetailsService } from 'src/app/shared/services/person-details.service';
import { People } from '../../../people/models/people.model';
import { Person } from 'src/app/people/models/person';
import { ActivatedRoute, Router } from '@angular/router';
import { Seat } from '../../models/team/seat';
import { SeatStatus } from '../../models/team/seatStatus';
import { CurrentWorkspaces } from '../../models/workspace/currentWorkspaces';
import { WorkspaceService } from '../../services/workspace.service';
import { map } from 'rxjs/operators';
import { generateChipStyle, PILL_KEY } from 'src/app/shared/models/attributes/attributeConstants';

@Component({
  selector: 'person-card',
  templateUrl: 'person-card.component.html',
  styleUrls: ['person-card.component.scss'],
  standalone: false
})
export class PersonCardComponent implements OnInit, OnDestroy {
  @Input()
  person: People | Person;
  @Input()
  link: any;
  @Input()
  seat: Seat;
  @Input()
  currentTeamsCount: number = 0;
  @Input()
  upcomingTeamsCount: number = 0;
  @Input()
  showSearchHint: boolean = true;
  @Input()
  selectEnabled: boolean = false;
  @Output()
  toggleSelectedPerson = new EventEmitter<{ personId: string; shiftClick: boolean }>();
  currentWorkspaces: CurrentWorkspaces;
  private subscriptions: Subscription[] = [];
  NoResponse: string = SeatStatus[SeatStatus.NoResponse];
  Declined: string = SeatStatus[SeatStatus.Declined];
  NoShow: string = SeatStatus[SeatStatus.NoShow];
  dataLoadingSubject = new Subject<void>();
  exactRating: number;
  personWorkspaceRating: number;
  private _personTeams: TeamHistory[];
  personCurrentTeams: TeamHistory[];
  personUpcomingTeams: TeamHistory[];
  hasRestrictedEvaluations: boolean = false;
  get personTeams(): TeamHistory[] {
    return this._personTeams;
  }

  private _sub: Subscription;
  constructor(
    private responsiveService: ResponsiveService,
    private personDetailsService: PersonDetailsService,
    private workspaceService: WorkspaceService,
    private router: Router,
    private route: ActivatedRoute
  ) {}
  ngOnDestroy(): void {
    if (this._sub) this._sub.unsubscribe();
  }
  ngOnInit(): void {
    this.subscriptions.push(
      this.workspaceService.currentWorkspaces
        .pipe(
          map((cws: CurrentWorkspaces) => {
            if (!cws) return null;
            return cws;
          })
        )
        .subscribe((result) => {
          if (result) {
            this.currentWorkspaces = result;
            var workspace = this.currentWorkspaces.activeWorkspace;
            if (workspace && workspace.restrictEvaluations) {
              this.hasRestrictedEvaluations = true;
              this.personDetailsService
                .getPersonWorkspaceRatingAggregate(this.person.id, workspace.id)
                .subscribe((rating) => {
                  if (!rating) {
                    return;
                  }
                  this.personWorkspaceRating = rating;
                });
            }
          }
        })
    );
  }

  openPersonDetailsDrawer() {
    this.responsiveService.toggleDrawerOpenClose(true);
  }

  getExactRating() {
    if (this.hasRestrictedEvaluations) {
      this.exactRating = this.personWorkspaceRating;
    } else {
      this.exactRating = this.person.rating;
    }
    if (this.exactRating == 1) {
      return this.exactRating + ' star';
    }
    return this.exactRating + ' stars';
  }

  getRating() {
    if (this.hasRestrictedEvaluations) {
      return this.personWorkspaceRating;
    }
    return this.person?.rating;
  }
  defaultPillColor: PILL_KEY = PILL_KEY.Gray;
  readonly getTagStyle: (key: PILL_KEY) => { [key: string]: string } | null = generateChipStyle;

  goToTeam(teamId) {
    if (this.isTeamInActiveWorkspace) this.router.navigate([`teams/${teamId}`]);
  }

  openMenu() {
    if (!this._personTeams || this._personTeams.length == 0) {
      this._sub = this.personDetailsService
        .getPersonTeamsHistory(this.person.id)
        .subscribe((teams) => {
          if (teams) {
            this._personTeams = teams.filter((t) => t.historicalTeamId == null && t.isActive);
            this.dataLoadingSubject.next();
            //fixes the double click problem
            this.dataLoadingSubject = null;
          }
        });
    }
  }

  openCurrentMenu() {
    let comp = this;
    if (!this.personCurrentTeams || this.personCurrentTeams.length == 0) {
      this._sub = this.personDetailsService
        .getCurrentPersonTeamsHistory(this.person.id)
        .subscribe((teams) => {
          if (teams) {
            this.personCurrentTeams = teams.filter(
              (t) =>
                t.historicalTeamId == null &&
                t.status != comp.NoShow &&
                t.status !== comp.Declined &&
                t.status != comp.NoResponse
            );
          }
        });
    }
  }

  openUpcomingMenu() {
    let comp = this;
    if (!this.personUpcomingTeams || this.personUpcomingTeams.length == 0) {
      this._sub = this.personDetailsService
        .getUpcomingPersonTeamsHistory(this.person.id)
        .subscribe((teams) => {
          if (teams) {
            this.personUpcomingTeams = teams.filter(
              (t) =>
                t.historicalTeamId == null &&
                t.isActive &&
                t.status != comp.NoShow &&
                t.status !== comp.Declined &&
                t.status != comp.NoResponse
            );
          }
        });
    }
  }

  onClickAvatar($event: MouseEvent, person: People | Person) {
    if (this.selectEnabled) {
      $event.stopPropagation();
      person.selected = !person.selected;
      this.toggleSelectedPerson.emit({ personId: person.id, shiftClick: $event.shiftKey });
    }
  }

  onClickRouterLink() {
    const link = Array.isArray(this.link) ? this.link : [];
    this.router.navigate([`./${link.join('/')}`], { relativeTo: this.route });
  }

  isTeamInActiveWorkspace(team: TeamHistory): boolean {
    if (!this.currentWorkspaces) return true;
    if (this.currentWorkspaces?.activeWorkspace.id == null && team.workspaceId == null) return true;
    if (this.currentWorkspaces?.activeWorkspace.name == team.workspaceName) return true;
    else return false;
  }
}
